// extracted by mini-css-extract-plugin
module.exports = {"root":"Select-module--root--1tnrT","title":"Select-module--title--2IR6Q"};